import { useState } from "react";
import { KeyRound } from "lucide-react"; // icon similar to screenshot

export default function SignatureVerificationCard({ className, onChange, initial = {} }) {
  const [enabled, setEnabled] = useState(initial.enabled ?? true);
  const [salt, setSalt] = useState(initial.salt ?? "");
  const [template, setTemplate] = useState(initial.template ?? "");

  // notify parent when values change
  const notify = (next) => {
    if (onChange) onChange(next);
  };

  const toggle = () => {
    const next = { enabled: !enabled, salt, template };
    setEnabled(!enabled);
    notify(next);
  };

  const onSalt = (v) => {
    setSalt(v);
    notify({ enabled, salt: v, template });
  };

  const onTemplate = (v) => {
    setTemplate(v);
    notify({ enabled, salt, template: v });
  };

  return (
    <div
      className={`w-full p-4 rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 mt-6 ${className}`}
    >
      {/* Header Row */}
      <div className="flex items-start justify-between">
        {/* Title & Description */}
        <div>
          <div className="flex items-center gap-2">
            <KeyRound size={18} className="text-orange-500" />
            <h2 className="text-xs font-semibold text-slate-800 dark:text-slate-100">
              Signature Verification
            </h2>
          </div>

          <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
            Enable signature verification for secure callbacks
          </p>
        </div>

        {/* Switch */}
        <button
          type="button"
          onClick={toggle}
          className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-300
            ${enabled ? "bg-blue-600" : "bg-slate-300"}`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300
              ${enabled ? "translate-x-4" : "translate-x-1"}`}
          />
        </button>
      </div>

      {/* Inputs Row - hide when disabled */}
      {enabled && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          {/* Salt Key */}
          <div>
            <label className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800">
              Salt Key
            </label>
            <input
              type="text"
              value={salt}
              onChange={(e) => onSalt(e.target.value)}
              placeholder="Your secret salt key"
              className="w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700"
            />
          </div>

          {/* Signature Template */}
          <div>
            <label className="text-sm font-sans mt-4 dark:text-slate-200 text-slate-800">
              Signature Template
            </label>
            <input
              type="text"
              value={template}
              onChange={(e) => onTemplate(e.target.value)}
              placeholder="e.g., {salt}.{user_id}.{value}.{token}"
              className="w-full px-2 py-2  bg-slate-100 dark:bg-slate-800 rounded-md 
                mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 focus:outline-none 
                focus:ring-2 focus:ring-blue-500 transition-all border border-slate-200 dark:border-slate-700"
            />
          </div>
        </div>
      )}
    </div>
  );
}
